import { render, staticRenderFns } from "./mGameInfo.vue?vue&type=template&id=6aee9a97&scoped=true"
import script from "./mGameInfo.vue?vue&type=script&lang=js"
export * from "./mGameInfo.vue?vue&type=script&lang=js"
import style0 from "./mGameInfo.vue?vue&type=style&index=0&id=6aee9a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee9a97",
  null
  
)

export default component.exports